import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { API_URL, EVENTO_SESION_VENCIDA } from './constants';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Un solo punto para las llamadas del portal: 401 del proxy = sesión vencida.
const fetchOriginal = window.fetch.bind(window);
window.fetch = async (recurso, opciones) => {
  const respuesta = await fetchOriginal(recurso, opciones);
  if (respuesta.status === 401 && String(recurso).startsWith(API_URL)) window.dispatchEvent(new Event(EVENTO_SESION_VENCIDA));
  return respuesta;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
